export interface RequestManagementDetailState {
  isLoading: boolean;
  dataDetail: any;
}

export const requestManagementDetailInitialState: RequestManagementDetailState = {
  isLoading: false,
  dataDetail: null,
};
